module.exports = __webpack_public_path__ + "img/settings.29af860a.svg";